export const CLASS_NAMES = [
    'audi', 'bentley', 'honda', 'hyundai', 'jaguar', 'lexus', 'mercedes', 'suzuki', 'tesla', 'toyota', 'volkswagen'
]